import React, {useCallback, useMemo, useRef} from "react";
import dayjs from 'dayjs';
import "./planScreen.css";
import {IClusterPlanLongItem, IGetPlanLongAPIParam,} from "../../../api/apiTypes";
import {CustomBreadcrumb} from "../../molecules/breadCrumb/CustomBreadcrumb";
import PlanMap, {IShippingPlanMarker} from "../../organisms/plan/PlanMap";
import {PlanControlButtons} from "../../organisms/plan/PlanControlButtons";
import {Layout, Row} from "antd";
import {PlanFilter} from "../../organisms/plan/PlanFilter";
import {extractExistingParams} from "../../../common/fns";
import {useSearchParams} from "react-router-dom";
import {SectorTable} from "../../organisms/plan/SectorTable";
import PlanTable from "../../organisms/plan/PlanTable";
import {SelectedShippings} from "../../organisms/selectedShippings/SelectedShippings";

export type ObjectWith = {
  [x: string]: any;
};

const now = dayjs();
const PlanMapScreen = () => {
  const [searchParams] = useSearchParams({plan_date: now.format("YYYY-MM-DD")});
  const tableRef = useRef<any>();
  const mapRef = useRef<any>();
  const controlRef = useRef<any>();
  const shippingControlRef = useRef<any>();
  
  const params: IGetPlanLongAPIParam = useMemo(() => {
    return extractExistingParams(searchParams);
  }, [searchParams]);
  
  const handleSelectShippings = useCallback((shipping: IShippingPlanMarker[]) => {
    console.log("handleSelectShippings", shipping);
    if (shippingControlRef.current) {
      shippingControlRef.current.setShippings(shipping);
    }
    if (controlRef.current) {
      controlRef.current.setShippings(shipping);
    }
  }, []);
  
  const handleResetControlShipping = useCallback(() => {
    if (controlRef.current) controlRef.current.setShippings([]);
    if (shippingControlRef.current) shippingControlRef.current.setShippings([]);
  }, []);
  
  const handleResetMapShippings = useCallback(() => {
    if (mapRef.current) {
      mapRef.current.reset();
    }
  }, []);
  
  const handleSelectPlans = useCallback((plans: IClusterPlanLongItem[]) => {
    console.log("handleSelectPlans", plans);
    if (controlRef.current) {
      controlRef.current.setPlans(plans);
    }
    if (mapRef.current) {
      mapRef.current.setPlans(plans);
    }
    handleResetControlShipping();
    handleResetMapShippings();
  }, [handleResetControlShipping, handleResetMapShippings]);
  
  const handleShippingShifted = useCallback(() => {
    console.log("handleUpdateShipping");
    if (tableRef.current) {
      tableRef.current.requestRefresh();
    }
  }, []);
  
  const handlePlanMerged = useCallback(() => {
    console.log("handleMergePlans");
    if (tableRef.current) {
      tableRef.current.requestRefresh(false, true);
    }
    handleResetControlShipping();
    handleResetMapShippings();
  }, [handleResetMapShippings, handleResetControlShipping]);
  
  const header = (<Row className={"breadcrumb-container"}>
    <CustomBreadcrumb shape={"round"} />
    <Row className={"right"}>
      <PlanFilter params={params} />
      <PlanControlButtons
        ref={controlRef}
        params={params}
        onShifted={handleShippingShifted}
        onMerged={handlePlanMerged}
        planNo={params.plan_no}
        planDate={params.plan_date}
      />
    </Row>
  </Row>);
  
  const filter = (<div className={"filter"}>
    <div className={"upper"}>
      <SectorTable params={params} />
      <PlanTable
        ref={tableRef}
        params={params}
        onSelectData={handleSelectPlans}
      />
    </div>
    <div className={"lower"}>
      <SelectedShippings
        ref={shippingControlRef} dataKey={"shipping_item__tracking_number"}
        onReset={handleResetMapShippings} />
    </div>
  </div>);
  
  return (<Layout className={"container-p5 plan"}>
    {header}
    <div className={"body"}>
      {filter}
      <PlanMap
        ref={mapRef}
        onSelectShippings={handleSelectShippings}
        onReset={handleResetControlShipping}
      />
    </div>
  </Layout>);
};

export default PlanMapScreen;
